// @flow
import * as React from 'react';
import { FormSpy } from 'react-final-form';
import type { FormSpyRenderProps } from 'react-final-form';

import { parseNumber, formatNumber } from '../../../utils/form';
import { getVisibleError } from '../../../hocs/final-form/utils';
import { FormField } from '../../../hocs/final-form';
import { validNumberReg } from './index';

import Field from '../../../basic-components/field';
import Input from '../../../basic-components/input';

import cs from './styles.pcss';
import t from '../locale';

type Props = {
  label: string,
  name: string,
  description: React.Node,
  defaultCurrency: string,
  veryLargeScreen?: boolean,
  priceFirstLabel?: string,
  priceAdditionalLabel?: string,
};

export const validCostIsNumberNoSetstate = (costInput: string): boolean => {
  if (validNumberReg.test(costInput)) {
    return true;
  }
  return false;
};

export default function ShippingPacketPrices({
  name,
  field,
  label,
  description,
  costInputErrorTip,
  costInputErrorTipPrice,
  costInputErrorTipAddition,
  fsChecked,
  globalDisabled,
  defaultCurrency,
  veryLargeScreen,
  firstCost,
  handleFirstCostInputChange,
  additionalCost,
  handleAdditionalCostInputChange,
  priceFirstLabel,
  priceAdditionalLabel,
}: Props): React.Node {
  return (
    <FormSpy>
      {({ form }: FormSpyRenderProps<any>) => {
        
        let error = null;
        let error1=null
        let error2=null
        
        const priceError = getVisibleError(form.getFieldState(field));
        if (priceError) {
          const price = form.getFieldState(`${field}.cost.price`);
          const additional = form.getFieldState(
            `${field}.cost.additional`
          );
          // console.log("price------",price,"additional------",additional)
          error1 = price && !validCostIsNumberNoSetstate(price?.value) ? t('fields.price.validate.notNumber') : null
          error2 = additional && !validCostIsNumberNoSetstate(additional?.value) ? t('fields.price.validate.notNumber') : null
          if (error1 == null && error2 == null) {
            error =
              price &&
                additional &&
                Number(price?.value || 0) < Number(additional?.value || 0)
                ? t('fields.price.validate.additionalHigher')
                : null;
          } else {
            error = null
          }
        }else {
          error = null
          error1 = null
          error2 = null
        }
        // console.log("error------",error,"error1------",error1,"error2------",error2)
        

             

        return (
        <>
          <Field
            label={label}
            description={description}
            // error={error}
            fieldClassName={cs.fieldClassName}
            noGrid={!veryLargeScreen}
          >
            {!veryLargeScreen && (
              <div className={cs.priceLabel}>{priceFirstLabel}</div>
            )}
           <div style={{position: "relative"}}>
           <FormField
              Component={Input}
              grid={6}
              error={error||costInputErrorTipPrice||costInputErrorTip||error1} //pass the error when onBlur
              key={`${field}.cost.price`}
              name={`${field}.cost.price`}
              className={cs.firstPrice}
              value={`${firstCost}`}
              disabled={globalDisabled || fsChecked}
              onChange={e=>handleFirstCostInputChange(e,`${field}.cost.price`)}
              autoComplete="off"
            />
             {
              ((costInputErrorTipPrice!="") && (!error)) && <span style={{ color: '#E62048', position: 'absolute', fontSize: '12px' }}>   {costInputErrorTipPrice}</span>
            }
           </div>
            {!veryLargeScreen && (
              <div className={cs.priceLabel}>{priceAdditionalLabel}</div>
            )}
           
           <div style={{position: "relative"}}>
           <FormField
              Component={Input}
              grid={6}
              error={error||costInputErrorTipAddition||costInputErrorTip||error2}
              key={`${field}.cost.additional`}
              name={`${field}.cost.additional`}
              className={cs.additionalPrice}
              value={`${additionalCost}`}
              disabled={globalDisabled || fsChecked}
              onChange={e=>handleAdditionalCostInputChange(e,`${field}.cost.additional`)}
              autoComplete="off"
            />
            {
              ((costInputErrorTipAddition!="") && (!error)) && <span style={{ color: '#E62048', position: 'absolute', left:'25px', fontSize: '12px' }}>   {costInputErrorTipAddition}</span>
            }
           </div>
          </Field>
          
           {/* error: validation errors displayed when submit */}
            {
              (error) && <span style={{ color: '#E62048', position: 'relative', left:'260px', fontSize: '12px' }}>   {error}</span>
            }

            {/* costInputErrorTip: display when failed in onblur validation */}
            {
              ((costInputErrorTip!="") && (!error)) && <span style={{ color: '#E62048', position: 'relative', left:'260px', fontSize: '12px' }}>   {costInputErrorTip}</span>
            }
            {/* costInputErrorTip2: display when failed in onblur validation */}
            
 </>
        );
      }}
    </FormSpy>
  );
}
